<template lang="html">
  <v-container
    grid-list-lg
    my-8
    fluid
  >
    <v-layout wrap>
      <v-flex
        v-bind="_pageLayout"
        mx-auto
      >
        <v-layout wrap>
          <v-flex
            xs12
            mb-4
            class="text-h2"
          >
            Privacy Policy
          </v-flex>
          <v-flex
            xs12
            class="font-weight-bold"
          >
            Last updated: {{ updated }}
          </v-flex>
          <v-flex
            xs12
            v-html="page.html"
          />
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import renderReady from '@/mixins/render-ready'
import { rtdb } from '@/plugins/firebase'


export default {
  mixins: [ renderReady ],
  data: () => ({
    page: {}
  }),
  computed: {
    ...mapGetters(['_pageLayout']),
    updated () {
      return this.page.updated 
          ? new Date(this.page.updated).toLocaleDateString()
          : ''
    }
  },
  beforeMount () {
    rtdb.ref('site/pages/privacyPolicy')
        .once('value')
        .then(s => this.page = s.val() || {})
  }
}
</script>

<style lang="css" >
 
</style>
